export const userEventNames = {
    SCH_COMPARE_URL: 'sch_compare_url',
    SCH_SNAPSHOT: 'sch_snapshot',
    SCH_METRICS: 'sch_metrics',
};
